export default {
  getDefaultState: () => {
    return {
      token: null,
      refreshTokenTimer: 0,
      isCallingLogin: false,
      user: {},
      impersonatedUser: null,
      errors: []
    }
  }
}
